import _ from 'lodash';
import moment from 'moment';
import React, { useState, useEffect } from 'react';
import ReportWidget from './ReportWidget';
import FlickityWidget from './FlickityWidget';
import LoadingPage from '../LoadingPage';
import Chart from '../../util/chart';

const SRF9Widget = () => {
  const [isReady, setIsReady] = useState(false);
  const [state, setState] = useState(null);

  const startdate = moment().subtract(90, 'days').format('MM-DD-YYYY');
  const enddate = moment().format('MM-DD-YYYY');

  const reportOptions = [startdate, enddate];

  const renderCharts = () => {
    Chart.makeSerialChart('srf9-widget-chart-1', {
      valueAxes: [
        {
          title: 'Dollars',
        },
      ],
      dataProvider: state.data1,
      graphs: state.graphs1,
      legend: {
        align: 'center',
        markerType: 'circle',
      },
    });

    Chart.makeSerialChart('srf9-widget-chart-2', {
      valueAxes: [
        {
          title: 'Hours',
        },
      ],
      dataProvider: state.data2,
      graphs: state.graphs2,
      legend: {
        align: 'center',
        markerType: 'circle',
      },
    });
  };

  useEffect(() => {
    if (isReady && state) {
      renderCharts();
    }
  }, [isReady, state]);

  const getData1 = data => {
    const ret = {};
    const final = [];
    const fields = ['laborbill', 'laborcost', 'othersales'];
    data.forEach(v => {
      const tmp = v.Initials.toUpperCase();

      if (ret[tmp]) {
        fields.forEach(f => {
          ret[tmp][f] += parseFloat(v[f] || '0');
        });
      } else {
        ret[tmp] = {};
        fields.forEach(f => {
          ret[tmp][f] = parseFloat(v[f] || '0');
        });
      }
    });

    _.forEach(ret, (v, k) => {
      const tmp = {};
      tmp.category = k;
      fields.forEach(f => {
        tmp[f] = v[f];
      });
      final.push(tmp);
    });

    return final;
  };

  const getGraphs1 = () => {
    const ret = [];
    const fields = {
      laborbill: 'Bill',
      laborcost: 'Cost',
      othersales: 'Other',
    };
    _.forEach(fields, (v, k) => {
      ret.push(
        Chart.getLineGraph({
          balloonText: "<span style='font-size:14px'><b>[[title]]</b> [[category]]<br>$[[value]]</span>",
          id: k,
          title: v,
          valueField: k,
          urlField: 'url',
        })
      );
    });
    return ret;
  };

  const getData2 = data => {
    const ret = {};
    const final = [];
    const fields = ['billhrs', 'costhrs'];
    data.forEach(v => {
      const tmp = v.Initials.toUpperCase();
      if (ret[tmp]) {
        fields.forEach(f => {
          ret[tmp][f] += parseFloat(v[f] || '0');
        });
      } else {
        ret[tmp] = {};
        fields.forEach(f => {
          ret[tmp][f] = parseFloat(v[f] || '0');
        });
      }
    });

    _.forEach(ret, (v, k) => {
      const tmp = {};
      tmp.category = k;
      fields.forEach(f => {
        tmp[f] = v[f];
      });
      final.push(tmp);
    });

    return final;
  };

  const getGraphs2 = () => {
    const ret = [];
    const fields = {
      billhrs: 'Bill',
      costhrs: 'Cost',
    };
    _.forEach(fields, (v, k) => {
      ret.push(
        Chart.getLineGraph({
          balloonText: "<span style='font-size:14px'><b>[[title]]</b> [[category]]<br>$[[value]]</span>",
          id: k,
          title: v,
          valueField: k,
          urlField: 'url',
        })
      );
    });
    return ret;
  };

  const handleData = ({ data, cols }) => {
    // transform array of positional data to array of json objects
    data.forEach((row, i) => {
      const obj = {};
      row.forEach((col, j) => {
        if (cols[j]) {
          obj[cols[j].name] = col;
        }
      });
      data[i] = obj;
    });

    setState({
      data1: getData1(data),
      graphs1: getGraphs1(data),
      data2: getData2(data),
      graphs2: getGraphs2(data),
    });

    setIsReady(true);
  };

  return (
    <ReportWidget pageName="SRF9" reportOptions={reportOptions} handleData={handleData}>
      {isReady ? (
        <FlickityWidget>
          <div id="srf9-widget-chart-2" className="carousel-cell" />
          <div id="srf9-widget-chart-1" className="carousel-cell" />
        </FlickityWidget>
      ) : (
        <LoadingPage />
      )}
    </ReportWidget>
  );
};

export default SRF9Widget;
